
export interface IHomeQuarterZoneValidation {
  quarters: HomeQuarterZones[];
  errors: string[];
}

export class HomeQuarterZones {
  public startZone: number;
  public endZone: number;
  public time: number;
  public error?: string;

  constructor(startZone: number) {
    this.startZone = startZone;
    this.time = 0;
  }
}
